// src/routes/ProtectedRoute.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function ProtectedRoute() {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("user_id");

  if (!token && !userId) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
